import {ReferralCampaignOffer} from './referral-campaign-offer';
import {convertObjectToDate} from '../_helpers/date_helper';

export class ReferralDetails {
  referralCampaignLinkId: string;
  code: string;
  referralCampaignId: string;
  referredBy: string;
  introductionText: string;
  completionText: string;
  hasHeaderImage: boolean;
  offer: ReferralCampaignOffer;

  constructor(data?: any) {
    if (data != null) {
      Object.assign(this, data);
    }
  }
}
